import { useEffect } from "react";

const SITE_ORIGIN = "https://xadentra.com";

// Lightweight per-page SEO updater (no react-helmet dependency)
export default function Seo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setOg = (prop, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", prop);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    // Resolve absolute URL for canonical + og:url.
    // Prefer the explicit `path` prop (clean, query-free), fall back to current pathname.
    // We deliberately strip any query string / hash so UTM-tagged or anchor-linked
    // landings still resolve to the same canonical page.
    const cleanPath = (path || window.location.pathname || "/").split("?")[0].split("#")[0];
    const absoluteUrl = SITE_ORIGIN + (cleanPath.startsWith("/") ? cleanPath : `/${cleanPath}`);

    setMeta("description", description);
    setOg("og:title", title);
    setOg("og:description", description);
    setOg("og:url", absoluteUrl);
    // Twitter card mirrors OG for SPA navigation so social share previews stay
    // route-accurate even without a hard refresh.
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", absoluteUrl);
  }, [title, description, path]);
  return null;
}
